/* eslint-disable react/prop-types */
import FormGeneric from './FormGeneric';
import FormCollab from './FormCollab';

export default function IncidentCollabForm({
    register, comments, errors, setFiles, setValue, usrId
}) {
    return (
        <> <br/> <FormCollab
            errors={errors}
            register={register}
        /> <br/> <FormGeneric
            comments={comments}
            errors={errors}
            register={register}
            setFiles={setFiles}
            setValue={setValue}
            usrId={usrId}
        /> </>
    );
}
